class ViewportService {
    public isInViewport(element: HTMLElement, margin: number = 0) {
        const bounding = element.getBoundingClientRect();
        return (
            bounding.top >= -margin &&
            bounding.left >= -margin &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + margin &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + margin
        );
    }
}

export const viewportService = new ViewportService();
